import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { BtnGroupWAStyle } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";

export default function ConfirmPopup(props: any) {
  return (
    <Grid container spacing={0}>
      <Grid item xs={12} textAlign="center" marginTop={6}>
        <Typography component={"div"} variant={"h6"} fontWeight={350}>
          Are you sure? Want to delete the record.
        </Typography>
      </Grid>
      <Grid item xs={12} textAlign="center" marginTop={5} className="btns">
        <BtnGroupWAStyle>
          <YSButton
            color="secondary"
            children="Cancel"
            variant="outlined"
            type="button"
            onClick={props.handleHideDeletePopupClick}
            size="large"
            className=""
          />{" "}
          <YSButton
            children="Confirm"
            variant="contained"
            type="button"
            onClick={() => {
              props.handleHideDeletePopupClick();
              props.deleteRowData();
            }}
            size="large"
            className=""
          />
        </BtnGroupWAStyle>
      </Grid>
    </Grid>
  );
}
